import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { getDateRangeWithSessionFallback } from '#component/general/date-range/helper';
import {
  FETCH_WAREHOUSE_LOGS,
  WAREHOUSE_LOGS_CLEAR,
  WAREHOUSE_LOGS_CHANGE_ORDER,
  FETCH_WAREHOUSE_LOGS_FAILED,
  FETCH_WAREHOUSE_LOGS_STARTED,
  WAREHOUSE_LOGS_PAGINATED_CHANGE_PAGE
} from '#action/types';
import { getRequestOptions, getDateRange, getURLParameter, setIdsParam } from '#helper';

let abortController = new AbortController();

export const fetchWarehouseLogs = () => async (dispatch, getState) => {
  try {
    abortController.abort();

    dispatch({
      type: FETCH_WAREHOUSE_LOGS_STARTED
    });

    const filter = getState().listFilter;
    const sourcePath = 'warehouse-log';
    const logFilter = filter[sourcePath];
    const urlPage = getURLParameter('page');
    const { page, itemsPerPage, order } = getState().warehouseLog;
    const offset = (Number(urlPage || page) - 1) * itemsPerPage;
    const searchParams = new URLSearchParams({
      order,
      offset,
      limit: 50
    });
    const applianceValue = logFilter?.appliance?.value;
    const warehouseValue = logFilter?.warehouse?.value;
    const userValue = logFilter?.user?.value;
    const { start: dateRangeStart, end: dateRangeEnd } = getDateRangeWithSessionFallback(
      logFilter?.start?.value,
      logFilter?.end?.value
    );
    const projectValue = logFilter?.project?.value;
    const eventValue = logFilter?.event?.value;
    setIdsParam(searchParams, 'appliance', applianceValue);
    setIdsParam(searchParams, 'warehouse', warehouseValue);
    setIdsParam(searchParams, 'user', userValue);
    setIdsParam(searchParams, 'project', projectValue);
    setIdsParam(searchParams, 'event', eventValue);

    if (dateRangeStart && dateRangeEnd) {
      const range = getDateRange(dateRangeStart, dateRangeEnd);
      searchParams.set('start', range.start);
      searchParams.set('end', range.end);
    }

    abortController = new AbortController();
    const { signal } = abortController;
    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });
    const url = webPortalApi.buildApiUrl(`warehouse/log?${searchParams.toString()}`);
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      const response = await res.json();
      dispatch({
        type: FETCH_WAREHOUSE_LOGS_FAILED,
        error: response
      });
      return dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
    }

    const { logs = [], last } = await res.json();

    return dispatch({
      type: FETCH_WAREHOUSE_LOGS,
      totalCount: last,
      payload: logs
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return false;
    }
    return dispatch({
      type: FETCH_WAREHOUSE_LOGS_FAILED,
      error: e
    });
  }
};

export const changeOrder = (newOrder, { refetch = true } = {}) => dispatch => {
  dispatch({
    type: WAREHOUSE_LOGS_CHANGE_ORDER,
    payload: newOrder
  });

  if (refetch) {
    dispatch(fetchWarehouseLogs());
  }
};

export const changePage = (newPage, { refetch = true } = {}) => dispatch => {
  dispatch({
    type: WAREHOUSE_LOGS_PAGINATED_CHANGE_PAGE,
    payload: newPage
  });

  if (refetch) {
    dispatch(fetchWarehouseLogs());
  }
};

export const clear = () => dispatch => {
  abortController.abort();
  dispatch({
    type: WAREHOUSE_LOGS_CLEAR
  });
};
